/**
 * Константы приложения
 */
export const HEADER_HEIGHT = 80;
export const MODAL_CLOSE_ANIMATION_DURATION = 100; // мс
export const MAX_STAR_RATING = 5;

